<nb-card class="nb_card_pop_up full_pop_up meal_item mobilePopup">

  <nb-card-header>
    <div class="title">
      <ng-container i18n="@@AddNewItemToBlock">Add New Exercise</ng-container>
    </div>
    <div class="actions">
      <!--<button i18n="@@AddNewItem" type="submit" style="width:120px;z-index: 1000;" class="btn-circle btn-xl btn-main StandardGreenButton" (click)="onNewCustomMealItem()">Add New Item</button>-->

      <button nbButton ghost  tabindex="-1">
        <nb-icon icon="close-outline" (click)="Accept()" style="z-index: 1000;"></nb-icon>
      </button>

    </div>
  </nb-card-header>

  <nb-card-body style="overflow:hidden">

    <!-- <div style="margin-bottom: 10px;">
    <input style="width:300px;" nbInput fullWidth shape="semi-round" i18n-placeholder="@@Filter" placeholder="Filter"
      (input)="FilterChange($event.target.value)" (keyup.enter)="ApplyFilterChange()"
      [nbAutocomplete]="autoControl" />
    <nb-autocomplete #autoControl>
      <nb-option *ngFor="let option of filteredFoods" [value]="option">
        {{ option }}
      </nb-option>
    </nb-autocomplete>
  </div> -->

    <div style="margin-bottom: 10px;" class="row meal_pop_up_header">

    


        <div class="col-12">
          <input style="width: 100%;" #SearchField autofocus tabindex="0" nbInput fullWidth shape="semi-round"
            i18n-placeholder="@@Filter" placeholder="Search Exercise..." (input)="FilterChange($event.target.value)"
            (keyup.enter)="ApplyFilterChange()" autofocus />
          <br />
          <a i18n="@@NotFindingWhatYouWant" (click)="onNewCustomFitnessItem()"
          style="cursor:pointer; font-size:12px; color:blue; text-decoration:underline; font-weight:normal;">Not
          finding
          what you want? Create a new exercise.</a>
      
        </div>

        <div class="col-12" style="margin-top:5px;">
          
        <nb-accordion>
          <nb-accordion-item  [expanded]="isDesktop()">
            <nb-accordion-item-header style="line-height: 0.5rem;padding:0.8rem !important; color:#383838;">Search Filters</nb-accordion-item-header>
            <nb-accordion-item-body>
              <div>

                <nb-select class="option-filter" multiple placeholder="Body Parts" [(ngModel)]="selectedBodyParts"
                  (ngModelChange)="onSelectedOptionsChange()">
                  <nb-option *ngFor="let bodyPart of allBodyParts" [value]="bodyPart.id">{{bodyPart.name}}</nb-option>
                </nb-select>

                <nb-select class="option-filter" multiple placeholder="Muscle Targets"
                  [(ngModel)]="selectedMuscleTargets" (ngModelChange)="onSelectedOptionsChange()">

                  <nb-option *ngFor="let muscle of allMuscleTargets" [value]="muscle.id">{{muscle.name}}</nb-option>

                </nb-select>

                <nb-select class="option-filter" multiple placeholder="Equipments" [(ngModel)]="selectedEquipments"
                  (ngModelChange)="onSelectedOptionsChange()">
                  <nb-option *ngFor="let equip of allEquipments" [value]="equip.id">{{equip.name}}</nb-option>
                </nb-select>

                <nb-checkbox class="option-filter" [(ngModel)]="withVideo" (ngModelChange)="onSelectedOptionsChange()">
                  With Video</nb-checkbox>

              </div>
            </nb-accordion-item-body>
          </nb-accordion-item>
        </nb-accordion>

        </div>
  
    </div>

    <nb-tabset class="food_array">
      <nb-tab class="food-tab" tabTitle="{{ExercisesListCountHTML}}" responsive
        style="overflow-y: hidden; height: 100%;">


        <virtual-scroller #ItemsWithImageScroll [items]="Items"
          style="height: 100%; min-height: 100px; padding-bottom:30px;" (vsEnd)="FetchMoreItem($event)"
          [bufferAmount]="5" [enableUnequalChildrenSizes]="true" [checkResizeInterval]="0">
          <div *ngFor="let item of ItemsWithImageScroll.viewPortItems">
            <app-exercise-edit [PatientID]="PatientID" [PatientName]="PatientName"
              [IsPreferredUnitImperial]="IsPreferredUnitImperial" [FitnessItem]="item" (added)="onAddItem($event)">
            </app-exercise-edit>
          </div>
          <div style="height:300px;"></div>
        </virtual-scroller>
      </nb-tab>

      <nb-tab class="food-tab" tabTitle="{{CustomExerciseListCountHTML}}" responsive>
        <virtual-scroller #CustomItemsScroll [items]="CustomItems" style="height: 100%; min-height: 100px;"
          [bufferAmount]="5" [enableUnequalChildrenSizes]="true" [checkResizeInterval]="0"
          (vsEnd)="FetchMoreCustomItem($event)">
          <div *ngFor="let item of CustomItemsScroll.viewPortItems">
            <app-exercise-edit [PatientID]="PatientID" [PatientName]="PatientName"
              [IsPreferredUnitImperial]="IsPreferredUnitImperial" [FitnessItem]="item" (added)="onAddItem($event)">
            </app-exercise-edit>
          </div>
        </virtual-scroller>
      </nb-tab>

    </nb-tabset>

  </nb-card-body>

</nb-card>